var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"images",class:{'images_mobile': _vm.$vuetify.breakpoint.xsOnly}},_vm._l((_vm.value),function(url){return _c('img',{staticClass:"images__img",attrs:{"src":_vm.fileStoreDomain+url}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }